import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useToast } from "@/hooks/use-toast";
import { Upload, Download } from "lucide-react";
import { DialogTitle, DialogHeader, DialogDescription } from "@/components/ui/dialog";
import { apiRequest } from "@/lib/queryClient";
import * as XLSX from "xlsx";
import axios from 'axios';
import BASE_URL from "@/constants";
export const UploadPOForm = () => {
  const REQUIRED_HEADERS = [
  "PO Number",
  "Item Code",
  "HSN Code",
  "Product UPC",
  "Product Description",
  "brand",
  "MRP",
  "Landing Rate",
  "Quantity",
  "Total Amount",
  "CGST %",
  "SGST %",
  "IGST %",
  "CESS %",
  "PO Released date",
  "PO Expirty Date",
  "Supplier",
  "po location"
];

  const [file, setFile] = useState<File | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const { toast } = useToast();
  const [platform, setPlatform] = useState<string>("");


  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      setFile(e.target.files[0]);
    }
  };



const handleFileUpload = async () => {
  // ... (keep all your existing validation code)

  try {
    const data = await ( file as any).arrayBuffer();
    const workbook = XLSX.read(data, { 
      type: "array",
      cellDates: true,
      cellText: false,
    });

    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];

    // First get the raw data
    const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, {
      defval: "",
      raw: true, // Get raw values first
    });
    
    if (!jsonData.length) {
      throw new Error("Uploaded file is empty or invalid format");
    }

    // Function to convert scientific notation to full string
    const convertScientific = (value: any): string => {
      if (typeof value === 'number') {
        // Convert number to string without scientific notation
        return value.toLocaleString('fullwide', { useGrouping: false });
      }
      if (typeof value === 'string' && value.includes('E+')) {
        // If it's already a string in scientific notation
        const num = parseFloat(value);
        return num.toLocaleString('fullwide', { useGrouping: false });
      }
      return String(value);
    };

    // Clean and transform data
    const cleanedData = jsonData.map(row => {
      const cleanedRow: any = {};
      for (const [header, value] of Object.entries(row)) {
        // Special handling for PO Number and Product UPC
        if (header === "PO Number" || header === "Product UPC") {
          cleanedRow[header] = convertScientific(value);
        } else {
          cleanedRow[header] = value;
        }
      }
      return cleanedRow;
    });

    // Check headers (your existing code)
    const uploadedHeaders = Object.keys(cleanedData[0]);
    const missingHeaders = REQUIRED_HEADERS.filter(header => !uploadedHeaders.includes(header));

    if (missingHeaders.length > 0) {
      toast({
        title: "Missing Header(s)",
        description: `The following headers are missing: ${missingHeaders.join(", ")}`,
        variant: "destructive",
      });
      return;
    }
    const payload = {
      platform,rows:cleanedData
    }

   try {
    const response = await axios.post(BASE_URL+'/api/excel-upload', payload);

   
    return response.data;
  } catch (error) {
    console.error('Upload failed:', error);
    throw error;
  }



  




   
    toast({
        title: "Uploaded PO Data(s)",
        // description: `The following headers are missing: ${missingHeaders.join(", ")}`,
        variant: "default",
      });

    // ... (rest of your success handling code)
  } catch (error) {
    // ... (your error handling code)
  } finally {
    
   
    setIsUploading(false);
  }
};

  const handleDownloadSample = () => {
    const link = document.createElement('a');
    link.href = '/sample-po.xls'; // File path in public folder
    link.download = 'sample-po.xls';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <DialogHeader>
        <DialogTitle>Upload New Master</DialogTitle>
        <DialogDescription>
          Upload new PO
        </DialogDescription>
      </DialogHeader>
      
      
      <div className="grid w-full items-center gap-1.5">
  <Label htmlFor="platform">Select Platform</Label>
  <select
    id="platform"
    value={platform}
    onChange={(e) => setPlatform(e.target.value)}
    className="border border-gray-300 rounded-md p-2 text-sm"
  >
    <option value="">-- Select Platform --</option>
    <option value="Swiggy Instamart">Swiggy Instamart</option>
    <option value="Blinkit">Blinkit</option>
    <option value="Zepto">Zepto</option>
  </select>
  <p className="text-sm text-gray-500">Choose the platform associated with this PO data</p>
</div>

      
    
      <div className="py-4">
           <div className="grid w-full items-center gap-1.5">
            <Label htmlFor="file-upload">Select PO Data File</Label>
            <Input
              id="file-upload"
              type="file"
              accept=".csv,.xlsx,.xls"
              onChange={handleFileChange}
            />
            <p className="text-sm text-gray-500">
              Upload Excel (.xlsx, .xls) or CSV (.csv) files containing PO data
            </p>
          </div>
            <div className="my-2">
        <Button 
          onClick={handleFileUpload} 
          disabled={!file || isUploading}
          className="w-full"
        >
          {isUploading ? (
            <>
              <Upload className="mr-2 h-4 w-4 animate-spin" />
              Uploading Master Data...
            </>
          ) : (
            <>
              <Upload className="mr-2 h-4 w-4" />
              Upload Master Data
            </>
          )}
        </Button>
        
      </div>
        <div className="space-y-4 mt-2">
          <Button
            variant="outline"
            className="w-full flex items-center justify-center"
            onClick={handleDownloadSample}
          >
            <Download className="mr-2 h-4 w-4" />
            Download Sample PO File
          </Button>

       

          {file && (
            <div className="p-3 bg-blue-50 border border-blue-200 rounded-md">
              <p className="text-sm font-medium text-blue-900">Selected file:</p>
              <p className="text-sm text-blue-700">{file.name}</p>
              <p className="text-xs text-blue-600 mt-1">
                Size: {(file.size / 1024).toFixed(1)} KB
              </p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
